<mat-sidenav-container>
  <mat-sidenav
    #sidenav
    [disableClose]="false"
    class="pl-2 min-w-[64px] max-w-[224px] !rounded-none sidenav-shadow h-[100vh] !z-50 !bg-white"
    mode="side"
    [opened]="isExpanded"
  >
    <div class="sidebar-content-container">
      <!-- Top section -->
      <div class="sidebar-section">
        <mat-nav-list>
          <app-sidebar-toggle-button
            [isExpanded]="isExpanded"
            (toggle)="toggleSidebar()"
          ></app-sidebar-toggle-button>
          <!-- Navigation history buttons -->
          <div class="flex justify-center">
            <app-history-navigation [isExpanded]="isExpanded"></app-history-navigation>
          </div>
        </mat-nav-list>

        <!-- Button group for top buttons -->
        <app-sidebar-button-group
          [buttons]="topButtons"
          [isExpanded]="isExpanded"
          (buttonClick)="onClickOnItem($event)"
        ></app-sidebar-button-group>
      </div>

      <div class="flex-grow"></div>

      <!-- Middle section -->
      <div class="sidebar-section">
        <!-- Status indicators section -->
        <app-sidebar-status-indicators
          [isExpanded]="isExpanded"
          [locatorStatus]="locatorStatus"
          (toggleTooltipEvent)="toggleTooltip($event.event, $event.template)"
        ></app-sidebar-status-indicators>
      </div>

      <mat-divider class="light-divider"></mat-divider>
      <!-- Bottom section -->
      <div class="sidebar-section">
        <!-- Button group for bottom buttons -->
        <app-sidebar-button-group
          [buttons]="bottomButtons"
          [isExpanded]="isExpanded"
          (buttonClick)="onClickOnItem($event)"
        ></app-sidebar-button-group>
        <app-sidebar-user-profile
          [userData]="userData"
          [showName]="true"
        ></app-sidebar-user-profile>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <div
      *ngIf="currentPath !== '/login'"
      class="flex flex-row h-[100vh] bg-[var(--color-background-primary-color)]"
    >
      <div
        *ngIf="!isExpanded"
        class="sidenav-shadow max-w-[64px] min-w-[64px] z-40 overflow-y-auto bg-white"
      >
        <div class="sidebar-content-container">
          <!-- Top section -->
          <div class="sidebar-section">
            <div>
              <mat-nav-list>
                <app-sidebar-toggle-button
                  [isExpanded]="false"
                  (toggle)="toggleSidebar()"
                ></app-sidebar-toggle-button>

                <!-- Navigation history buttons - collapsed sidebar -->
                <div class="flex justify-center">
                  <app-history-navigation [isExpanded]="false"></app-history-navigation>
                </div>
              </mat-nav-list>
            </div>

            <!-- Button group for top buttons -->
            <app-sidebar-button-group
              [buttons]="topButtons"
              [isExpanded]="false"
              (buttonClick)="onClickOnItem($event)"
            ></app-sidebar-button-group>
          </div>

          <div class="flex-grow"></div>

          <!-- Middle section -->
          <div class="sidebar-section">
            <!-- Status indicators section -->
            <app-sidebar-status-indicators
              [isExpanded]="false"
              [locatorStatus]="locatorStatus"
              (toggleTooltipEvent)="toggleTooltip($event.event, $event.template)"
            ></app-sidebar-status-indicators>
          </div>

          <mat-divider class="light-divider"></mat-divider>
          <!-- Bottom section -->
          <div class="sidebar-section">
            <!-- Button group for bottom buttons -->
            <app-sidebar-button-group
              [buttons]="bottomButtons"
              [isExpanded]="false"
              (buttonClick)="onClickOnItem($event)"
            ></app-sidebar-button-group>
            <app-sidebar-user-profile
              [userData]="userData"
              [showName]="false"
            ></app-sidebar-user-profile>
          </div>
        </div>
      </div>
      <div class="flex-grow" (click)="isExpanded ? closeSidebar() : null">
        <router-outlet></router-outlet>
      </div>
    </div>
    <router-outlet *ngIf="currentPath === '/login'"></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
